module.exports = __webpack_public_path__ + "media/images/front/pc/shared/signup_banner-104c056c877a0373228bcea8381501fa.png";